// ICP main component
// link to backend swagger page:
// https://dev-apigateway.connexing.io/icp-service/swagger-ui/index.html

import React, { useCallback, useEffect, useState } from "react";
import ContentHeader from "../ShareElements/ContentHeader/ContentHeader";
import "../../../../Assets/Styles/Communication.scss";
import ChatlistEmptyState from "./Components/ChatlistEmptyState";
import SearchInput from "../ShareElements/SearchInput/SearchInput";
import ChatItem from "./Components/ChatItem";
import DeleteModal from "./Components/DeleteModal";
import { Config } from "../../../../Config";
import axios from "axios";
import LoadingSkeleton from "./Components/LoadingSkeleton";
import CandidateInfo from "./Components/CandidateInfo";
import JPAInfo from "./Components/JPAInfo";
import ManagerInfo from "./Components/ManagerInfo";
import CursorPopup from "../ShareElements/CursorPopup/CursorPopUp";

const Communication = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  var stompClient = null;
  const [ConversationData, setConversationData] = useState([]);
  const [PinnedConversations, setPinnedConversation] = useState([]);
  const [StompClient, setStompClient] = useState(null);
  const [InputPlaceholderIsShown, setInputPlaceholderIsShown] = useState(true);
  const [InitialLoadIsDone, setInitialLoadIsDone] = useState(false);
  const [ContextMenuIsOpen, setContextMenuIsOpen] = useState(false);
  const [FilterIsOpen, setFilterIsOpen] = useState(false);
  const [LastKeyPressed, setLastKeyPressed] = useState("");
  const [SelectedFilter, setSelectedFilter] = useState(
    translateText("my_applications")
  );
  const [ConversationMessages, setConversationMessages] = useState([]);
  const [DeleteIsOpen, setDeleteIsOpen] = useState(false);
  const [SelectedSource, setSelectedSource] = useState(
    window.localStorage.getItem("chat_source")
  ); // "APPLICATION" or "CANDIDATE"
  const [RecipientId, setRecipientId] = useState(
    window.localStorage.getItem("chat_recipientId")
  );
  const [ResultIsEmpty, setResIsEmpty] = useState(false);
  const [JPAId, setJPAId] = useState(window.localStorage.getItem("chat_jpaId"));
  const [DeleteModalInfo, setDeleteModalInfo] = useState(undefined);
  const [ChatHeaderInfo, setChatHeaderInfo] = useState();
  const [JPAType, setJPAType] = useState(
    window.localStorage.getItem("chat_jpaType")
  );
  const [InitialConvSelected, setInitialConvSelected] = useState(false);
  const [NewConvIsCreated, setNewConvCreated] = useState(false);
  const [SkeletonIsShown, setSkeletonIsShown] = useState(true);
  const [CandidateInfoIsOpen, setCandidateInfoIsOpen] = useState(false);
  const [ManagerInfoIsOpen, setManagerInfoIsOpen] = useState(false);
  const [JPAInfoIsOpen, setJPAInfoIsOpen] = useState(false);
  const [SelectedChatIndex, setSelectedChatIndex] = useState(0);
  const [CandidateInfoData, setCandidateInfo] = useState();
  const [ManagerInfoData, setManagerInfo] = useState();
  const [JPAInfoData, setJPAInfo] = useState();
  const [TempChat, setTempChat] = useState();
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    if (window.innerWidth <= 1024 && window.innerWidth >= 600) {
      setIsTablet(true);
    }
    if (
      window.innerWidth > 450 &&
      document.getElementById("icp-bookmark") !== null
    ) {
      document.getElementById("icp-bookmark").click();
    }
    if (window.localStorage.getItem("chat_jpaType") === "project") {
      setJPAType("project");
    } else if (window.localStorage.getItem("chat_jpaType") === "activity") {
      setJPAType("activity");
    } else {
      setJPAType("position");
    }
    if (window.localStorage.getItem("chat_jpaId") === null) {
      window.localStorage.removeItem("TempChatroom");
    }
    handleTempChatStatus();
    //executed on component mount.
    if (SelectedSource === null) {
      setSelectedSource("APPLICATION");
    }
    handleChatInfo();

    return () => {
      //executed on component unmount.
      stompClient.unsubscribe("/user/" + props.UserInfo.id + "/queue/messages");
      stompClient.disconnect();
    };
  }, []);

  const handleTempChatStatus = () => {
    if (window.localStorage.getItem("TempChatroom") !== null) {
      let TempChatObject = JSON.parse(
        atob(window.localStorage.getItem("TempChatroom"))
      );
    }
  };

  const handleInitialTab = () => {
    let ChatJPAType = window.localStorage.getItem("chat_jpaType");
    if (ChatJPAType === "position") {
      toggleChatListTab("jobs-tab");
    } else if (ChatJPAType === "project") {
      toggleChatListTab("projects-tab");
    } else if (ChatJPAType === "activity") {
      toggleChatListTab("activities-tab");
    }
  };

  const handleChatInfo = () => {
    let WorkCity = window.localStorage.getItem("chat_workCiy");
    let JPATitle = window.localStorage.getItem("chat_title");
    let ChatJPAId = window.localStorage.getItem("chat_jpaId");
    let ChatRecipientId = window.localStorage.getItem("chat_recipientId");
    let ChatJPAType = window.localStorage.getItem("chat_jpaType");
    let ChatSource = window.localStorage.getItem("chat_source");

    if (ChatSource === null) {
      setSelectedSource("APPLICATION");
    }
    if (ChatJPAId === null) {
      fetchChatlist("APPLICATION", "position");
    }

    if (
      ChatJPAId !== null &&
      ChatRecipientId !== null &&
      WorkCity !== null &&
      JPATitle !== null &&
      ChatJPAType !== null &&
      ChatSource !== null
    ) {
      handleSelectIntitialSource(ChatSource);
      handleInitialTab();
      fetchMessages(
        ChatSource,
        ChatRecipientId,
        props.UserInfo.id,
        ChatJPAId,
        ChatJPAType
      );
      setChatHeaderInfo({
        title: JPATitle,
        details: null,
        workCity: WorkCity,
        jpaId: JPAId,
      });
    } else {
      setChatHeaderInfo(undefined);
    }
    connect();
  };

  const selectInitialConversation = useCallback(
    (
      ChatJPAId,
      ChatJPAType,
      ChatId,
      PreventOpenParent,
      PreSelectedChatIndex,
      WillNotFetchChats
    ) => {
      let ConversationId = ChatJPAId + ChatJPAType + "-trigger";
      let ChatRowId = ChatId + "-chat-0";
      if (PreSelectedChatIndex !== undefined) {
        ChatRowId = ChatId + "-chat-" + PreSelectedChatIndex;
      } else {
        ChatRowId = ChatId + "-chat-0";
      }
      if (
        document.getElementById(ConversationId) !== null &&
        document.getElementById(ChatRowId) !== null
      ) {
        if (
          !PreventOpenParent &&
          !document
            .getElementById(ChatJPAId + ChatJPAType + "-chevron")
            .classList.contains("rotated-icon")
        ) {
          document.getElementById(ConversationId).click();
          // if (!WillNotFetchChats) {
          // }
        }
        setTimeout(() => {
          document.getElementById(ChatRowId).click();
          if (document.getElementById(ChatRowId) !== null) {
          }
        }, 100);
      }
      setInitialConvSelected(true);
    },
    [ConversationData]
  );

  const handleSelectIntitialSource = (Source) => {
    if (Source === "APPLICATION") {
      handleSelectChatFilter("my-applications-chat-filter");
    } else {
      handleSelectChatFilter("candidates-chat-filter");
    }
  };

  const fetchMessages = (
    Source,
    RecipientId,
    SenderId,
    JPAId,
    Type,
    ChatItem
  ) => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.ICPServiceURL +
        "/api/" +
        Type +
        "/messages/" +
        Source +
        "/" +
        RecipientId +
        "/" +
        SenderId +
        "/" +
        JPAId,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };

    axios(Req)
      .then((Res) => {
        console.log(Res);
        // adds a conversation item inside the array in case the related
        // JPA has been deleted
        if (ChatItem && ChatItem.jpaDeleted) {
          setConversationMessages([
            ...Res.data,
            {
              updatedTime: new Date().toISOString(),
              content: translateText("ICP_deleted_jpa_message"),
              isDeleteMessage: true,
              recipientId: "",
            },
          ]);
        } else {
          setConversationMessages(Res.data);
        }
        scrollConversation();
        if (Res.data.length === 0 && !NewConvIsCreated && !InitialLoadIsDone) {
          toggleFirstTimeMessage(Type, RecipientId, Source);
        } else {
          let ChatJPAId = window.localStorage.getItem("chat_jpaId");
          let ChatJPAType = window.localStorage.getItem("chat_jpaType");
          if (ChatJPAType !== null && ChatJPAId !== null) {
            var SelectedChatId = null;
            Res.data.map((Item) => {
              if (Item.jpaId === ChatJPAId) {
                SelectedChatId = Item.details[0].chatId;
              }
            });
            if (!InitialConvSelected && SelectedChatId !== null) {
              selectInitialConversation(
                ChatJPAId,
                ChatJPAType,
                SelectedChatId,
                false
              );
            }
          }
        }
        if (RecipientId === null && SenderId === null && JPAId === null) {
          fetchChatlist(SelectedSource, JPAType, false);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  // if the number of messages between the 2 people is 0, it is considered that there is no chat item
  // and this function creates the temporary chatroom that is saved after pin/unpin is triggered. Before the
  // trigger, the temp chat only exists in the FE.
  // The API call in this function is used for fetching the info of the recipient such as
  // profile image, background color and text color to put inside the temp chatroom data object.
  const toggleFirstTimeMessage = (Type, RecipientId, Source) => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.ICPServiceURL +
        "/api/employee/profile/" +
        RecipientId,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-type": "application/json",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        var TempChatroom = {
          jpaId: window.localStorage.getItem("chat_jpaId"),
          title: window.localStorage.getItem("chat_title"),
          workCity: window.localStorage.getItem("chat_workCiy"),
          details: [
            {
              firstName: Res.data.firstName,
              lastName: Res.data.lastName,
              defaultTextColorCode: Res.data.defaultTextColorCode,
              defaultBackgroundColorCode: Res.data.defaultBackgroundColorCode,
              imageUrl: Res.data.imageUrl,
              imageThumbnailUrl: Res.data.imageThumbnailUrl,
              currentPositionTitle: Res.data.currentPositionTitle,
              updatedTime: new Date().toISOString(),
              senderId: props.UserInfo.id,
              recipientId: window.localStorage.getItem("chat_recipientId"),
              chatId: "temp-chat",
              jpaId: window.localStorage.getItem("chat_jpaId"),
              counter: 0,
            },
          ],
          bookmarked: false,
        };
        setTempChat({
          type: JPAType,
          chat: TempChatroom,
        });
        validateConvIsNew(TempChatroom, Type, Source);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  // validates wether the created temp-chat is actually new or not
  // (i.e. there's already a chat item in the list)
  const validateConvIsNew = (NewChatroom, Type, Source) => {
    let ChatroomObj = JSON.stringify(NewChatroom);
    let ChatroomBase64 = Buffer.from(ChatroomObj).toString("base64");
    window.localStorage.setItem("TempChatroom", ChatroomBase64);

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.ICPServiceURL +
        "/api/" +
        Type +
        "/chat/list",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        nameLike: document.getElementById("search-input").value,
        source: Source,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        var ChatJPAIds = [];
        var RecipientIds = [];
        Res.data.map((Item) => {
          ChatJPAIds.push(Item.jpaId);
          Item.details.map((detail) => {
            RecipientIds.push(detail.recipientId);
          });
        });
        if (ChatJPAIds.indexOf(NewChatroom.jpaId) === -1) {
          let Conversations = [...Res.data];
          Conversations.unshift(NewChatroom);
          filterPinnedconversations(
            Conversations,
            Type,
            Source,
            true,
            NewChatroom
          );
        } else {
          if (RecipientIds.indexOf(NewChatroom.details[0].recipientId) === -1) {
            let ExistantChatIndex = ChatJPAIds.indexOf(NewChatroom.jpaId);
            let Conversations = [...Res.data];
            let ConversationChats = [
              ...Conversations[ExistantChatIndex].details,
            ];
            ConversationChats.unshift(NewChatroom.details[0]);
            Conversations[ExistantChatIndex].details = ConversationChats;
            filterPinnedconversations(
              Res.data,
              Type,
              Source,
              false,
              NewChatroom
            );
          } else {
            // chat is already there but it's empty with no messages sent/received
            let Conversations = [...Res.data];
            let ParentIndex = ChatJPAIds.indexOf(NewChatroom.jpaId); // the chat category index
            let ChatItems = Conversations[ParentIndex].details;
            let RecipientIds = [];
            ChatItems.map((Item) => {
              RecipientIds.push(Item.recipientId);
            });
            let ChatIndexToSelect = RecipientIds.indexOf(RecipientId);
            let ChatId =
              Conversations[ParentIndex].details[ChatIndexToSelect].chatId +
              "-chat-" +
              ChatIndexToSelect; // the format of the id passed to selectInitialConversation()  is : ChatId + "-chat-[Index]"
            selectInitialConversation(
              Conversations[ParentIndex].jpaId,
              Type,
              ChatId,
              true,
              ChatIndexToSelect
            );
          }
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  // Source is based on 2 filters for the catlist that are as following:
  // "my applications" : "APPLICATION"
  // "candidates" : "CANDIDATE"
  // WillSelectConversation : boolean to keep the selected chat conversation active (classnames)
  // WillResetConversations is passed as true when we want to reset the open parents (close the open chats on the chat list)
  // PreSelectedChatId, PreSelectedChatIndex, PreselectedChatJPAId are passed to the function filterPinnedconversations() to re-select the chat after updating the list when pin/unpin happens
  const fetchChatlist = useCallback(
    (
      Source,
      Type,
      WillResetConversations,
      PreSelectedChatId,
      PreSelectedChatIndex,
      PreselectedChatJPAId,
      WillSelectConversation
    ) => {
      if (Type === null) {
        Type = "position";
      }
      if (Source === null) {
        Source = "APPLICATION";
      }

      let Req = {
        method: "POST",
        baseURL:
          window._env_.API_URL +
          Config.ICPServiceURL +
          "/api/" +
          Type +
          "/chat/list",
        headers: {
          Authorization: "Bearer " + window.localStorage.getItem("Token"),
          "Content-Type": "application/json",
        },
        data: {
          nameLike: document.getElementById("search-input").value,
          source: Source,
        },
      };
      axios(Req)
        .then((Res) => {
          console.log(Res);

          if (WillResetConversations) {
            setConversationData([]);
          }

          // The data is first filtered through this function and the set as states (pinned and unpinned chats)
          filterPinnedconversations(
            Res.data,
            Type,
            Source,
            true,
            undefined,
            PreSelectedChatId,
            PreSelectedChatIndex,
            PreselectedChatJPAId,
            WillSelectConversation
          );
          setInitialLoadIsDone(true);
          let ChatJPAId = window.localStorage.getItem("chat_jpaId");
          let ChatRecipientId = window.localStorage.getItem("chat_recipientId");
          let ChatJPAType = window.localStorage.getItem("chat_jpaType");

          if (ChatJPAId === null && ChatRecipientId === null) {
            return null;
          } else if (!InitialLoadIsDone) {
            var SelectedChatId;
            var ConversationIndex = 0; // based on the recipientId set for the conversatio item inside the collapsible area
            let ChatListItemIds = []; // Collapsible row trigger item ids
            var RecipientIDs = []; // Ids of the chats inside each collapsible
            Res.data.map((Item) => {
              ChatListItemIds.push(Item.jpaId);
              if (Item.jpaId === ChatJPAId) {
                Item.details.map((DetailItem) => {
                  RecipientIDs.push(DetailItem.recipientId);
                });
              }
              if (Item.jpaId === ChatJPAId) {
                ConversationIndex = RecipientIDs.indexOf(RecipientId);
              }
              if (Item.jpaId === ChatJPAId) {
                SelectedChatId = Item.details[ConversationIndex].chatId;
              }
            });
            setTimeout(() => {
              selectInitialConversation(
                ChatJPAId,
                ChatJPAType,
                SelectedChatId,
                false,
                ConversationIndex,
                true
              );
            }, 2000);
          }
        })
        .catch((Err) => {
          console.log(Err);
        });
    },
    [ConversationData]
  );

  // After fetching the chat list, the data from API is passed to this function to
  // filter the chat items that are pinned from the rest and set the to the related state.
  // AllItems contains all pinned/unpinned chats list
  // Type is JPAType (position || project || activity)
  // Source chat source ("APPLICATION" || "CANDIDATE")
  // ConversationExists is a boolean the is passed as true when the created temp chat already exists in the chat list
  // NewChatroom the temp-chat created (contains parent and only 1 chat item that is the new temp chat created)
  // PreSelectedChatId, PreSelectedChatIndex, PreselectedChatJPAId are used for reselecting the selected chat after updating the list with pin/unpin trigger
  const filterPinnedconversations = (
    AllItems,
    Type,
    Source,
    ConversationExists,
    NewChatroom,
    PreSelectedChatId,
    PreSelectedChatIndex,
    PreselectedChatJPAId,
    WillSelectConversation
  ) => {
    let PinnedChats = [];
    let FilteredChats = []; // chat list without the pinned items
    if (AllItems.length > 0) {
      AllItems.map((Conversation) => {
        if (Conversation.bookmarked) {
          PinnedChats.push(Conversation);
        } else {
          FilteredChats.push(Conversation);
        }
      });
      setConversationData(FilteredChats);
    } else {
      setConversationData(AllItems);
    }
    setPinnedConversation(PinnedChats);
    if (PinnedChats.length === 0 && FilteredChats.length === 0) {
      setResIsEmpty(true);
    } else {
      setResIsEmpty(false);
    }

    setTimeout(() => {
      if (PreSelectedChatId !== null && PreSelectedChatId !== undefined) {
        selectInitialConversation(
          PreselectedChatJPAId,
          JPAType,
          PreSelectedChatId,
          false,
          PreSelectedChatIndex
        );
      }
    }, 800);

    if (NewChatroom !== undefined) {
      setTimeout(() => {
        if (ConversationExists && AllItems.length > 1) {
          setTimeout(() => {
            selectInitialConversation(
              NewChatroom.jpaId,
              Type,
              "temp-chat",
              false
            );
          }, 2000);
        } else {
          var ChatJPAIds = [];
          var Chats = FilteredChats.concat(PinnedChats);
          Chats.map((Chat) => {
            ChatJPAIds.push(Chat.jpaId);
          });
          if (Source === "APPLICATION") {
            setTimeout(() => {
              selectInitialConversation(
                NewChatroom.jpaId,
                Type,
                NewChatroom.details[0].chatId,
                false
              );
            }, 1000);
          } else {
            let SelectedChatIndex = ChatJPAIds.indexOf(NewChatroom.jpaId);

            if (Chats[SelectedChatIndex].details.length <= 1) {
              setTimeout(() => {
                selectInitialConversation(
                  NewChatroom.jpaId,
                  Type,
                  NewChatroom.details[0].chatId,
                  false
                );
              }, 1000);
            } else {
              setTimeout(() => {
                selectInitialConversation(
                  NewChatroom.jpaId,
                  Type,
                  NewChatroom.details[0].chatId,
                  false
                );
              }, 1000);
            }
          }
        }
      }, 800);
    }
    // In case the conversation which is selected and has active className is updated and moved in the list
    // this condition will handle the situation by activating the chat (collapsible will open if closed) and
    // add the classNames by clicking the related chat conversation. It will also close all the other open
    // collapsibles if they are open.
    setTimeout(() => {
      if (WillSelectConversation) {
        var IsPinned = false; // determines if the chat we're on, is pinned or not
        if (
          document.getElementById(JPAId + Type + "-pin") &&
          document
            .getElementById(JPAId + Type + "-pin")
            .classList.contains("pinned")
        ) {
          IsPinned = true;
        }

        if (IsPinned) {
          if (
            document.getElementById(JPAId + Type + "-chevron").classList
              .length === 1 //the chat parent is not open
          ) {
            document
              .getElementById(PinnedChats[0].jpaId + Type + "-trigger")
              .click();
          }
          document
            .getElementById(PinnedChats[0].details[0].chatId + "-chat-0")
            .click();
        } else {
          if (
            document.getElementById(JPAId + Type + "-chevron").classList
              .length === 1 //the chat parent is not open
          ) {
            document
              .getElementById(AllItems[0].jpaId + Type + "-trigger")
              .click();
          }
          document
            .getElementById(AllItems[0].details[0].chatId + "-chat-0")
            .click();
        }

        //closing part
        // TODO: make it in sync with the selecting to prevent wrong open/closes

        // let AllChats = AllItems.concat(PinnedChats);
        // AllChats.map((Chat) => {
        //   if (Chat.jpaId !== JPAId) {
        //     document.getElementById(Chat.jpaId + Type + "-trigger").click();
        //   }
        // });
      }
    }, 500);
  };

  const connect = () => {
    const Stomp = require("stompjs");
    var SockJS = require("sockjs-client");
    SockJS = new SockJS(
      window._env_.API_URL + Config.ICPServiceURL + "/ws",
      null,
      { transports: ["xhr-polling"] }
    );
    stompClient = Stomp.over(SockJS);
    setStompClient(stompClient);
    stompClient.connect({}, onConnected, onError);
  };

  const onConnected = () => {
    setSkeletonIsShown(false);
    scrollConversation();
    stompClient.subscribe(
      "/user/" + props.UserInfo.id + "/queue/messages",
      onMessageReceived
    );
  };

  const onError = (err) => {
    console.log(err);
  };

  const sendMessage = (msg) => {
    if (msg.trim() !== "") {
      const message = {
        senderId: props.UserInfo.id,
        recipientId: RecipientId,
        jpaId: JPAId,
        source: SelectedSource,
        type: JPAType,
        content: document.getElementById("message-input").value,
      };
      StompClient.send("/app/chat", {}, JSON.stringify(message), onError);
      let Messages = [...ConversationMessages];
      Messages.push({
        updatedTime: new Date().toISOString(),
        content: msg,
        status: "DELIVERED",
        senderId: props.UserInfo.id,
        recipientId: RecipientId,
      });
      setConversationMessages(Messages);
      resetChatInput();
      scrollConversation();
      scrollChatList();
      fetchChatlist(
        SelectedSource,
        JPAType,
        false,
        undefined,
        undefined,
        undefined,
        true // a boolean to stay on the selected conversation in the caht list
      );
    }
  };

  const scrollChatList = () => {
    document.getElementById("chat-list").scrollTop = 0;
  };

  // The ChatIsSelected boolean determines wether the chat where we received a message is
  // selected or not. if it's selected we fetch the messages of that chat, otherwise we fetch
  // the chatlist to update the list.
  const onMessageReceived = (Message) => {
    var MessageBody = JSON.parse(Message.body);
    var ChatIsSelected = false;
    var Type = "activity";
    var Source = "APPLICATION";

    if (
      document.getElementById("jobs-tab").classList.contains("active-tab-item")
    ) {
      Type = "position";
    } else if (
      document
        .getElementById("projects-tab")
        .classList.contains("active-tab-item")
    ) {
      Type = "project";
    }

    if (
      document.getElementById(
        MessageBody.chatId + "-chat-" + SelectedChatIndex
      ) !== null &&
      document
        .getElementById(MessageBody.chatId + "-chat-" + SelectedChatIndex)
        .classList.contains("selected-row")
    ) {
      ChatIsSelected = true;
    }

    if (
      document.getElementById("filter-text") !== null &&
      document.getElementById("filter-text").innerHTML ===
        translateText("candidates")
    ) {
      Source = "CANDIDATE";
    }

    if (MessageBody.senderId !== props.UserInfo.id && ChatIsSelected) {
      fetchChatlist(Source, Type, false);
      fetchMessages(
        Source,
        MessageBody.senderId,
        props.UserInfo.id,
        MessageBody.jpaId,
        Type,
        Message
      );
    } else {
      fetchChatlist(
        Source,
        Type,
        false,
        undefined,
        undefined,
        undefined,
        false
      );
    }
  };

  const scrollConversation = () => {
    if (document.getElementById("messages-conversation-wrapper") !== null) {
      let ScrollHeight = document.getElementById(
        "messages-conversation-wrapper"
      ).scrollHeight;
      document.getElementById("messages-conversation-wrapper").scrollTop =
        ScrollHeight;
    }
  };

  const handleMessageInput = (e) => {
    if (e.target.value.length === 0) {
      setInputPlaceholderIsShown(true);
    } else if (InputPlaceholderIsShown) {
      setInputPlaceholderIsShown(false);
    }

    document.getElementById("message-input-shadow").innerHTML = e.target.value;
    handleMessageInputSize();
  };

  const handleMessageInputSize = () => {
    let ContentHeigth = document.getElementById(
      "message-input-shadow"
    ).clientHeight;
    let HeightValue = ContentHeigth + "px";
    if (ContentHeigth <= 216) {
      document.getElementById("message-input").style.height = HeightValue;
    } else {
      document.getElementById("message-input").style.height = "264px";
    }
  };

  const toggleChatListTab = (SelectedTab) => {
    setManagerInfoIsOpen(false);
    setJPAInfoIsOpen(false);
    let TabIds = ["jobs-tab", "projects-tab", "activities-tab"];

    TabIds.map((TabId) => {
      document.getElementById(TabId).classList.remove("active-tab-item");
    });
    document.getElementById(SelectedTab).classList.add("active-tab-item");

    let SelectedIndex = TabIds.indexOf(SelectedTab);
    if (SelectedIndex === 0) {
      //jobs tab
      if (isTablet)
        document.getElementById("chat-tab-indicator").style.transform =
          "translateX(20%)";
      else
        document.getElementById("chat-tab-indicator").style.transform =
          "translateX(32%)";

      setJPAType("position");
      if (!SkeletonIsShown) {
        fetchChatlist(SelectedSource, "position");
      }

      document.getElementById("project-chat-list").classList.add("hidden");
      document.getElementById("activity-chat-list").classList.add("hidden");
      document.getElementById("job-chat-list").classList.remove("hidden");
      document
        .getElementById("project-chat-list")
        .classList.remove("chat-list-transformed");
      document
        .getElementById("activity-chat-list")
        .classList.remove("chat-list-transformed");
      document
        .getElementById("job-chat-list")
        .classList.add("chat-list-transformed");

      setTimeout(() => {
        document
          .getElementById("job-chat-list")
          .classList.remove("chat-list-transformed");
      }, 500);
    } else if (SelectedIndex === 1) {
      // projects tab
      if (isTablet)
        document.getElementById("chat-tab-indicator").style.transform =
          "translateX(160%)";
      else
        document.getElementById("chat-tab-indicator").style.transform =
          "translateX(199%)";

      setJPAType("project");
      if (!SkeletonIsShown) {
        fetchChatlist(SelectedSource, "project");
      }

      document.getElementById("project-chat-list").classList.remove("hidden");
      document.getElementById("activity-chat-list").classList.add("hidden");
      document.getElementById("job-chat-list").classList.add("hidden");
      document
        .getElementById("job-chat-list")
        .classList.remove("chat-list-transformed");
      document
        .getElementById("activity-chat-list")
        .classList.remove("chat-list-transformed");
      document
        .getElementById("project-chat-list")
        .classList.add("chat-list-transformed");

      setTimeout(() => {
        document
          .getElementById("project-chat-list")
          .classList.remove("chat-list-transformed");
      }, 500);
    } else {
      // activities tab
      if (isTablet)
        document.getElementById("chat-tab-indicator").style.transform =
          "translateX(340%)";
      else
        document.getElementById("chat-tab-indicator").style.transform =
          "translateX(365%)";

      setJPAType("activity");
      if (!SkeletonIsShown) {
        fetchChatlist(SelectedSource, "activity");
      }

      document.getElementById("project-chat-list").classList.add("hidden");
      document.getElementById("activity-chat-list").classList.remove("hidden");
      document.getElementById("job-chat-list").classList.add("hidden");
      document
        .getElementById("project-chat-list")
        .classList.remove("chat-list-transformed");
      document
        .getElementById("activity-chat-list")
        .classList.add("chat-list-transformed");
      document
        .getElementById("job-chat-list")
        .classList.remove("chat-list-transformed");

      setTimeout(() => {
        document
          .getElementById("activity-chat-list")
          .classList.remove("chat-list-transformed");
      }, 500);
    }
    setChatHeaderInfo(undefined);
    // setConversationData([]);
  };

  const removeConversationsActiveState = () => {
    PinnedConversations.map((Item) => {
      if (document.getElementById(Item.jpaId + JPAType + "-trigger") !== null) {
        document
          .getElementById(Item.jpaId + JPAType + "-trigger")
          .classList.remove("selected-conversation");
        Item.details.map((Row, i) => {
          if (document.getElementById(Row.chatId + "-chat-" + i) !== null) {
            document
              .getElementById(Row.chatId + "-chat-" + i)
              .classList.remove("selected-row");
          }
        });
      }
    });
    ConversationData.map((Item) => {
      if (document.getElementById(Item.jpaId + JPAType + "-trigger") !== null) {
        document
          .getElementById(Item.jpaId + JPAType + "-trigger")
          .classList.remove("selected-conversation");
        Item.details.map((Row, i) => {
          if (document.getElementById(Row.chatId + "-chat-" + i) !== null) {
            document
              .getElementById(Row.chatId + "-chat-" + i)
              .classList.remove("selected-row");
          }
        });
      }
    });
  };
  const addConversationActiveState = (ConversationId, ChatRowId) => {
    if (
      document.getElementById(ConversationId) !== null &&
      document.getElementById(ChatRowId)
    ) {
      document
        .getElementById(ConversationId)
        .classList.add("selected-conversation");
      document.getElementById(ChatRowId).classList.add("selected-row");
    }
  };

  const closeMobileMessageList = () => {
    document.getElementById("message-list").classList.remove("list-on-screen");
    document.getElementById("mobile-nav-header").classList.remove("hidden");
    if (window.innerWidth <= 450) {
      document.getElementById("chat-list").style.pointerEvents = "unset";
    }
    removeConversationsActiveState();
  };

  const selectChat = (Chat, i, IsPinned) => {
    setTimeout(() => {
      if (window.innerWidth <= 450) {
        document.getElementById("chat-list").style.pointerEvents = "none";
      }
      if (CandidateInfoIsOpen) {
        setCandidateInfoIsOpen(false);
      }
      if (ManagerInfoIsOpen) {
        setManagerInfoIsOpen(false);
      }
      if (JPAInfoIsOpen) {
        setJPAInfoIsOpen(false);
      }
      if (window.innerWidth <= 550) {
        document.getElementById("message-list").classList.add("list-on-screen");
        document.getElementById("mobile-nav-header").classList.add("hidden");
      }
      setSelectedChatIndex(i);
      let ConversationId;
      let ChatRowId;
      if (IsPinned) {
        ConversationId = Chat.jpaId + JPAType + "-pinned-trigger";
        ChatRowId = Chat.details[i].chatId + "-pinned-chat-" + i;
      } else {
        ConversationId = Chat.jpaId + JPAType + "-trigger";
        ChatRowId = Chat.details[i].chatId + "-chat-" + i;
      }

      removeConversationsActiveState();
      addConversationActiveState(ConversationId, ChatRowId, IsPinned);

      setChatHeaderInfo(Chat);

      setDeleteModalInfo({
        jpa_name: Chat.title,
        recipient_name:
          Chat.details[i].firstName + " " + Chat.details[i].lastName,
      });
      setRecipientId(Chat.details[i].recipientId);
      setJPAId(Chat.jpaId);
      fetchMessages(
        SelectedSource,
        Chat.details[i].recipientId,
        props.UserInfo.id,
        Chat.jpaId,
        JPAType,
        Chat
      );
      if (
        !SkeletonIsShown &&
        InitialLoadIsDone &&
        Chat.details[i].chatId !== "temp-chat"
      ) {
        fetchChatlist(SelectedSource, JPAType, false);
      }
      setTimeout(() => {
        scrollConversation();
      }, 500);
    }, 400);
  };

  const togglesendMessage = () => {
    if (document.getElementById("message-input").value.length > 0) {
      sendMessage(document.getElementById("message-input").value);
    }
  };

  const resetChatInput = () => {
    document.getElementById("message-input").focus();
    setInputPlaceholderIsShown(true);
    document.getElementById("message-input").value = "";
    document.getElementById("message-input").style.height = "32px";

    setTimeout(() => {
      scrollConversation();
    }, 500);
  };

  const handleKeyPress = (KeyEvent) => {
    if (KeyEvent.code === "ShiftLeft" || KeyEvent.code === "ShiftRight") {
      setLastKeyPressed(KeyEvent.code);
    } else if (LastKeyPressed !== "") {
      setLastKeyPressed("");
    }
    if (KeyEvent.code === "Enter" || KeyEvent.code === "NumpadEnter") {
      if (LastKeyPressed !== "ShiftLeft" || LastKeyPressed !== "ShiftRight") {
        KeyEvent.preventDefault();
        sendMessage(document.getElementById("message-input").value);
      }
    }
  };

  const handleSelectChatFilter = (Id) => {
    removeConversationsActiveState();
    let RowIds = ["my-applications-chat-filter", "candidates-chat-filter"];
    RowIds.map((Item) => {
      if (document.getElementById(Item) !== null) {
        document.getElementById(Item).classList.remove("selected-chat-filter");
      }
    });
    if (document.getElementById(Id) !== null) {
      document.getElementById(Id).classList.add("selected-chat-filter");
    }
    if (Id === RowIds[0]) {
      setSelectedFilter("My Applications");
      setSelectedSource("APPLICATION");
      fetchChatlist("APPLICATION", JPAType);
    } else {
      setSelectedFilter("Candidates");
      setSelectedSource("CANDIDATE");
      fetchChatlist("CANDIDATE", JPAType);
    }
    setTimeout(() => {
      if (document.getElementById("filters-outline") !== null) {
        document.getElementById("filters-outline").click();
      }
      setChatHeaderInfo(undefined);
    }, 100);
  };

  const handleOpenCloseChatlistFilter = (Action) => {
    if (Action === "open") {
      setFilterIsOpen(true);
      document
        .getElementById("chat-list-filter-icon")
        .classList.add("icon-rotated");

      document.getElementById("chat-list-head").classList.add("on-top");
    } else {
      setFilterIsOpen(false);
      document
        .getElementById("chat-list-filter-icon")
        .classList.remove("icon-rotated");

      if (document.getElementById("chat-list").scrollTop === 0) {
        document.getElementById("chat-list-head").classList.remove("on-top");
      }
    }
  };

  const toggleDeleteConversation = () => {
    setContextMenuIsOpen(false);
    setDeleteIsOpen(true);
  };

  const displayMessageTime = (Time) => {
    return new Date(Time).getHours() + ":" + new Date(Time).getMinutes();
  };

  const removeTempChat = () => {
    fetchChatlist(SelectedSource, JPAType, true);
    setDeleteIsOpen(false);
    setTempChat(undefined);
    setChatHeaderInfo(undefined);
    removeConversationsActiveState();
  };

  const acceptDeleteConversation = () => {
    if (
      TempChat !== undefined &&
      ChatHeaderInfo.jpaId === TempChat.chat.jpaId &&
      ConversationMessages.length === 0 &&
      !ChatHeaderInfo.bookmarked
    ) {
      removeTempChat();
    } else {
      let Req = {
        method: "DELETE",
        baseURL:
          window._env_.API_URL +
          Config.ICPServiceURL +
          "/api/" +
          JPAType +
          "/messages",
        headers: {
          Authorization: "Bearer " + window.localStorage.getItem("Token"),
          "Content-Type": "application/json",
        },
        data: {
          chatRoomId: ChatHeaderInfo.details[SelectedChatIndex].chatId,
          senderId: props.UserInfo.id,
          source: SelectedSource,
          jpaId: ChatHeaderInfo.jpaId,
        },
      };
      axios(Req)
        .then((Res) => {
          console.log(Res);
          setChatHeaderInfo(undefined);
          fetchChatlist(SelectedSource, JPAType);
          setDeleteIsOpen(false);
          removeConversationsActiveState();
        })
        .catch((Err) => {
          console.log(Err.response);
        });
    }
  };

  const displayJPAinfoText = () => {
    if (JPAType === "position") {
      return "Job information";
    } else if (JPAType === "project") {
      return "Project information";
    } else {
      return "Activity information";
    }
  };

  const displayRecipient = () => {
    if (SelectedSource === "APPLICATION") {
      return translateText("owner_info");
    } else {
      return translateText("candidate_info");
    }
  };

  const handleIsMeChatBobbleClassName = (Index) => {
    if (Index === 0) {
      return "message-holder is-me radioused-right";
    } else if (
      Index > 0 &&
      ConversationMessages[Index - 1].senderId !== props.UserInfo.id
    ) {
      return "message-holder is-me radioused-right";
    } else {
      return "message-holder is-me";
    }
  };

  const handleChatBobbleClassName = (Index) => {
    if (Index === 0) {
      return "message-holder radioused-left";
    } else if (
      Index > 0 &&
      ConversationMessages[Index - 1].senderId === props.UserInfo.id
    ) {
      if (ConversationMessages[Index].isDeleteMessage) {
        return "message-holder radioused-left red-informative-message";
      } else {
        return "message-holder radioused-left";
      }
    } else {
      return "message-holder";
    }
  };

  const displayJPATitle = () => {
    let Title = ChatHeaderInfo.title;
    var JPADeleted = ChatHeaderInfo.jpaDeleted;
    if (Title.length <= 38) {
      return (
        <p className={JPADeleted ? "jpa-title crossed-out" : "jpa-title"}>
          {Title}
          <p className="popup-text">{Title}</p>
        </p>
      );
    } else {
      let Shortened = Title.slice(0, 34) + " ...";
      return (
        <p className={JPADeleted ? "jpa-title crossed-out" : "jpa-title"}>
          {Shortened}
          <p className="popup-text">{Title}</p>
        </p>
      );
    }
  };

  const displayWorkCity = () => {
    var WorkCity = ChatHeaderInfo.workCity;
    if (WorkCity) {
      if (WorkCity.length <= 44) {
        return <p className="jpa-location-name">{ChatHeaderInfo.workCity}</p>;
      } else {
        let Shortened = WorkCity.slice(0, 40) + " ...";
        return (
          <p className="jpa-location-name">
            <CursorPopup ShortText={Shortened} FullText={WorkCity} />
          </p>
        );
      }
    } else {
      return translateText("not_available");
    }
  };

  const fetchManagerInfo = () => {
    let BaseURL = Config.PositionServiceURL;
    if (JPAType === "project") {
      BaseURL = Config.ProjectServiceURL;
    } else if (JPAType === "activity") {
      BaseURL = Config.ActivityServiceURL;
    }
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        BaseURL +
        "/api/" +
        JPAType +
        "/manager/" +
        ChatHeaderInfo.details[SelectedChatIndex].recipientId,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setManagerInfo(Res.data);
        if (CandidateInfoIsOpen) {
          setCandidateInfoIsOpen(false);
        }
        setManagerInfoIsOpen(true);
        setContextMenuIsOpen(false);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const fetchChandidateInfo = () => {
    let BaseURL = Config.PositionServiceURL;
    if (JPAType === "project") {
      BaseURL = Config.ProjectServiceURL;
    } else if (JPAType === "activity") {
      BaseURL = Config.ActivityServiceURL;
    }
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        BaseURL +
        "/api/" +
        JPAType +
        "/" +
        ChatHeaderInfo.jpaId +
        "/candidate/" +
        ChatHeaderInfo.details[SelectedChatIndex].recipientId,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setCandidateInfo(Res.data);
        if (ManagerInfoIsOpen) {
          setManagerInfoIsOpen(false);
        }
        setCandidateInfoIsOpen(true);
        setContextMenuIsOpen(false);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const toggleRecipientInfo = () => {
    if (JPAInfoIsOpen) {
      setJPAInfoIsOpen(false);
    }
    if (SelectedSource === "APPLICATION") {
      fetchManagerInfo();
    } else {
      fetchChandidateInfo();
    }
  };

  const toggleJPAInfo = () => {
    if (ManagerInfoIsOpen) {
      setManagerInfoIsOpen(false);
    }

    if (CandidateInfoIsOpen) {
      setCandidateInfoIsOpen(false);
    }

    let BaseURL = Config.PositionServiceURL;
    if (JPAType === "project") {
      BaseURL = Config.ProjectServiceURL;
    } else if (JPAType === "activity") {
      BaseURL = Config.ActivityServiceURL;
    }

    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        BaseURL +
        "/api/" +
        JPAType +
        "/" +
        ChatHeaderInfo.jpaId,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setJPAInfo(Res.data);
        setContextMenuIsOpen(false);
        setJPAInfoIsOpen(true);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const handleChatlistScrollEvents = () => {
    if (document.getElementById("chat-list").scrollTop === 0) {
      document.getElementById("chat-list-head").classList.remove("on-top");
    } else {
      document.getElementById("chat-list-head").classList.add("on-top");
    }
  };

  return (
    <div className="main-content">
      <ContentHeader PageName={translateText("communication")} />
      <div className="content-header">
        <div className="address">
          <p>{translateText("communication")}</p>
        </div>
      </div>
      <main className="icp-wrapper">
        {DeleteIsOpen ? (
          <DeleteModal
            Close={() => setDeleteIsOpen(false)}
            ConversationInfo={DeleteModalInfo}
            AcceptDelete={() => acceptDeleteConversation()}
            LangData={props.LangData}
          />
        ) : null}
        {SkeletonIsShown ? <LoadingSkeleton LangData={props.LangData} /> : null}
        <div
          className="chat-list"
          id="chat-list"
          onScroll={() => handleChatlistScrollEvents()}
        >
          <section className="chat-list-head" id="chat-list-head">
            <SearchInput
              Placeholder={translateText("search") + " ..."}
              OnChange={() => fetchChatlist(SelectedSource, JPAType)}
            />
            {props.IsSuperAdmin || props.IsHRAdmin || props.IsMSS ? (
              <div className="dropdown-wrapper">
                {FilterIsOpen ? (
                  <div
                    className="outline"
                    id="filters-outline"
                    onClick={() => handleOpenCloseChatlistFilter("close")}
                  ></div>
                ) : null}
                <div
                  className="dropdown-trigger"
                  onClick={() => handleOpenCloseChatlistFilter("open")}
                >
                  <h1 id="filter-text">{SelectedFilter}</h1>
                  <i
                    className="feather-chevron-down"
                    id="chat-list-filter-icon"
                  ></i>
                  <React.Fragment>
                    <div
                      className={
                        FilterIsOpen ? "chat-list-filter-content" : "hidden"
                      }
                    >
                      <section
                        className="chat-list-filter-row selected-chat-filter"
                        id="my-applications-chat-filter"
                        onClick={() =>
                          handleSelectChatFilter("my-applications-chat-filter")
                        }
                      >
                        {translateText("my_applications")}{" "}
                        <i className="feather-check"></i>
                      </section>
                      <section
                        className="chat-list-filter-row"
                        id="candidates-chat-filter"
                        onClick={() =>
                          handleSelectChatFilter("candidates-chat-filter")
                        }
                      >
                        {translateText("candidates")}{" "}
                        <i className="feather-check"></i>
                      </section>
                    </div>
                  </React.Fragment>
                </div>
              </div>
            ) : (
              <div className="dropdown-wrapper">
                <div
                  className="dropdown-trigger"
                  onClick={() => handleOpenCloseChatlistFilter("open")}
                >
                  <h1>{translateText("my_applications")}</h1>
                </div>
              </div>
            )}
            <div className="chat-list-tabs">
              <section
                className="tab-item active-tab-item"
                id="jobs-tab"
                onClick={() => toggleChatListTab("jobs-tab")}
              >
                {translateText("jobs")}
              </section>
              <section
                className="tab-item"
                id="projects-tab"
                onClick={() => toggleChatListTab("projects-tab")}
              >
                {translateText("projects")}
              </section>
              <section
                className="tab-item"
                id="activities-tab"
                onClick={() => toggleChatListTab("activities-tab")}
              >
                {translateText("activities")}
              </section>
              <span id="chat-tab-indicator"></span>
            </div>
          </section>
          {!InitialLoadIsDone ||
          (ConversationData.length === 0 &&
            PinnedConversations.length === 0) ? (
            <ChatlistEmptyState Text={"No conversation available."} />
          ) : null}
          <div className="chat-items-wrapper" id="job-chat-list">
            {PinnedConversations.length === 0 ||
            JPAType !== "position" ? null : (
              <div className="pinned-chats">
                {PinnedConversations.map((Conversation, i) => (
                  <ChatItem
                    Id={Conversation.jpaId + "position"}
                    IsPinned
                    IndexStart={PinnedConversations.length}
                    LangData={props.LangData}
                    SelectChat={(ChatIndex, i) =>
                      selectChat(Conversation, ChatIndex, i, true)
                    }
                    Conversation={Conversation}
                    ChatItems={Conversation.details}
                    JPAType={JPAType}
                    JPAId={Conversation.jpaId}
                    SelectedSource={SelectedSource}
                    SelectedChatIndex={SelectedChatIndex}
                    FetchChatlist={(
                      WillReset,
                      PreSelectedChatId,
                      PreSelectedChatIndex,
                      ChatJPAId
                    ) =>
                      fetchChatlist(
                        SelectedSource,
                        JPAType,
                        WillReset,
                        PreSelectedChatId,
                        PreSelectedChatIndex,
                        ChatJPAId
                      )
                    }
                    SenderId={props.UserInfo.id}
                  />
                ))}
              </div>
            )}
            <div className="unpinned-chats">
              {ConversationData.map((Conversation, i) => (
                <React.Fragment>
                  {JPAType === "position" ? (
                    <ChatItem
                      Id={Conversation.jpaId + "position"}
                      SelectChat={(ChatIndex, i) =>
                        selectChat(Conversation, ChatIndex, i, false)
                      }
                      Conversation={Conversation}
                      LangData={props.LangData}
                      ChatItems={Conversation.details}
                      JPAType={JPAType}
                      JPAId={Conversation.jpaId}
                      SelectedSource={SelectedSource}
                      SelectedChatIndex={SelectedChatIndex}
                      FetchChatlist={(
                        WillReset,
                        PreSelectedChatId,
                        PreSelectedChatIndex,
                        ChatJPAId
                      ) =>
                        fetchChatlist(
                          SelectedSource,
                          JPAType,
                          WillReset,
                          PreSelectedChatId,
                          PreSelectedChatIndex,
                          ChatJPAId
                        )
                      }
                      SenderId={props.UserInfo.id}
                    />
                  ) : null}
                </React.Fragment>
              ))}
            </div>
          </div>
          <div className="chat-items-wrapper hidden" id="project-chat-list">
            {PinnedConversations.length === 0 ||
            JPAType !== "project" ? null : (
              <div className="pinned-chats">
                {PinnedConversations.map((Conversation, i) => (
                  <ChatItem
                    Id={Conversation.jpaId + "project"}
                    SelectChat={(ChatIndex, i) =>
                      selectChat(Conversation, ChatIndex, i, true)
                    }
                    IsPinned
                    LangData={props.LangData}
                    IndexStart={PinnedConversations.length}
                    Conversation={Conversation}
                    ChatItems={Conversation.details}
                    JPAType={JPAType}
                    JPAId={Conversation.jpaId}
                    SelectedSource={SelectedSource}
                    SelectedChatIndex={SelectedChatIndex}
                    FetchChatlist={(
                      WillReset,
                      PreSelectedChatId,
                      PreSelectedChatIndex,
                      ChatJPAId
                    ) =>
                      fetchChatlist(
                        SelectedSource,
                        JPAType,
                        WillReset,
                        PreSelectedChatId,
                        PreSelectedChatIndex,
                        ChatJPAId
                      )
                    }
                    SenderId={props.UserInfo.id}
                  />
                ))}
              </div>
            )}
            <div className="unpinned-chats">
              {ConversationData.map((Conversation, i) => (
                <React.Fragment>
                  {JPAType === "project" ? (
                    <ChatItem
                      Id={Conversation.jpaId + "project"}
                      SelectChat={(ChatIndex, i) =>
                        selectChat(Conversation, ChatIndex, i, false)
                      }
                      Conversation={Conversation}
                      ChatItems={Conversation.details}
                      LangData={props.LangData}
                      JPAType={JPAType}
                      JPAId={Conversation.jpaId}
                      SelectedSource={SelectedSource}
                      SelectedChatIndex={SelectedChatIndex}
                      FetchChatlist={(
                        WillReset,
                        PreSelectedChatId,
                        PreSelectedChatIndex,
                        ChatJPAId
                      ) =>
                        fetchChatlist(
                          SelectedSource,
                          JPAType,
                          WillReset,
                          PreSelectedChatId,
                          PreSelectedChatIndex,
                          ChatJPAId
                        )
                      }
                      SenderId={props.UserInfo.id}
                    />
                  ) : null}
                </React.Fragment>
              ))}
            </div>
          </div>
          <div className="chat-items-wrapper hidden" id="activity-chat-list">
            {PinnedConversations.length === 0 ||
            JPAType !== "activity" ? null : (
              <div className="pinned-chats">
                {PinnedConversations.map((Conversation, i) => (
                  <ChatItem
                    Id={Conversation.jpaId + "activity"}
                    SelectChat={(ChatIndex, i) =>
                      selectChat(Conversation, ChatIndex, i, true)
                    }
                    IsPinned
                    IndexStart={PinnedConversations.length}
                    LangData={props.LangData}
                    Conversation={Conversation}
                    ChatItems={Conversation.details}
                    JPAType={JPAType}
                    JPAId={Conversation.jpaId}
                    SelectedSource={SelectedSource}
                    SelectedChatIndex={SelectedChatIndex}
                    FetchChatlist={(
                      WillReset,
                      PreSelectedChatId,
                      PreSelectedChatIndex,
                      ChatJPAId
                    ) =>
                      fetchChatlist(
                        SelectedSource,
                        JPAType,
                        WillReset,
                        PreSelectedChatId,
                        PreSelectedChatIndex,
                        ChatJPAId
                      )
                    }
                    SenderId={props.UserInfo.id}
                  />
                ))}
              </div>
            )}
            <div className="unpinned-chats">
              {ConversationData.map((Conversation, i) => (
                <React.Fragment>
                  {JPAType === "activity" ? (
                    <ChatItem
                      Id={Conversation.jpaId + "activity"}
                      SelectChat={(ChatIndex, i) =>
                        selectChat(Conversation, ChatIndex, i, false)
                      }
                      Conversation={Conversation}
                      ChatItems={Conversation.details}
                      LangData={props.LangData}
                      JPAType={JPAType}
                      JPAId={Conversation.jpaId}
                      SelectedSource={SelectedSource}
                      SelectedChatIndex={SelectedChatIndex}
                      FetchChatlist={(
                        WillReset,
                        PreSelectedChatId,
                        PreSelectedChatIndex,
                        ChatJPAId
                      ) =>
                        fetchChatlist(
                          SelectedSource,
                          JPAType,
                          WillReset,
                          PreSelectedChatId,
                          PreSelectedChatIndex,
                          ChatJPAId
                        )
                      }
                      SenderId={props.UserInfo.id}
                    />
                  ) : null}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
        <div className="message-list" id="message-list">
          {CandidateInfoIsOpen ? (
            <CandidateInfo
              Close={() => setCandidateInfoIsOpen(false)}
              Data={CandidateInfoData}
              Type={JPAType}
              LangData={props.LangData}
            />
          ) : null}
          {ManagerInfoIsOpen ? (
            <ManagerInfo
              Close={() => setManagerInfoIsOpen(false)}
              Data={ManagerInfoData}
              Type={JPAType}
              LangData={props.LangData}
            />
          ) : null}
          {JPAInfoIsOpen ? (
            <JPAInfo
              Close={() => setJPAInfoIsOpen(false)}
              Data={JPAInfoData}
              Type={JPAType}
              LangData={props.LangData}
            />
          ) : null}
          {ChatHeaderInfo !== undefined ? (
            <React.Fragment>
              {window.innerWidth > 450 ? (
                <section className="message-list-head">
                  {displayJPATitle()}
                  <span className="jpa-location">
                    <i className="feather-map-pin"></i>
                    {displayWorkCity()}
                  </span>
                  <i
                    className="feather-more-vertical"
                    onClick={() => setContextMenuIsOpen(true)}
                  ></i>
                  {ContextMenuIsOpen ? (
                    <React.Fragment>
                      <div
                        className="outline"
                        onClick={() => setContextMenuIsOpen(false)}
                      ></div>
                      <div className="contex-menu">
                        <section
                          className="context-menu-row"
                          onClick={() => toggleRecipientInfo()}
                        >
                          <i className="feather-user"></i>
                          <p>{displayRecipient()}</p>
                        </section>
                        <section
                          className="context-menu-row"
                          onClick={() => toggleJPAInfo()}
                        >
                          <i className="feather-info"></i>
                          <p>{displayJPAinfoText()}</p>
                        </section>
                        <section
                          className="context-menu-row red-row"
                          onClick={() => toggleDeleteConversation()}
                        >
                          <i className="feather-trash-2"></i>
                          <p>{translateText("delete_conversation")}</p>
                        </section>
                      </div>
                    </React.Fragment>
                  ) : null}
                </section>
              ) : (
                <section className="message-list-head mobile-message-list-head">
                  <i
                    className="feather-arrow-left"
                    onClick={() => closeMobileMessageList()}
                  ></i>
                  <React.Fragment>
                    {ChatHeaderInfo === undefined ||
                    ChatHeaderInfo.details === null ? null : (
                      <React.Fragment>
                        {ChatHeaderInfo.details[SelectedChatIndex]
                          .imageThumbnailUrl === null ? (
                          <span
                            className="avatar-holder"
                            style={{
                              background:
                                ChatHeaderInfo.details[SelectedChatIndex]
                                  .defaultBackgroundColorCode,
                              color:
                                ChatHeaderInfo.details[SelectedChatIndex]
                                  .defaultTextColorCode,
                            }}
                          >
                            {ChatHeaderInfo.details[SelectedChatIndex].firstName
                              .slice(0, 1)
                              .toUpperCase() +
                              ChatHeaderInfo.details[SelectedChatIndex].lastName
                                .slice(0, 1)
                                .toUpperCase()}
                          </span>
                        ) : (
                          <img
                            alt=""
                            src={
                              ChatHeaderInfo.details[SelectedChatIndex]
                                .imageThumbnailUrl
                            }
                          />
                        )}
                        <div className="recipient-identity">
                          <p className="recipient-name">
                            {ChatHeaderInfo.details[SelectedChatIndex]
                              .firstName +
                              " " +
                              ChatHeaderInfo.details[SelectedChatIndex]
                                .lastName}
                          </p>
                          <p className="recipient-position">
                            {
                              ChatHeaderInfo.details[SelectedChatIndex]
                                .currentPositionTitle
                            }
                          </p>
                        </div>
                      </React.Fragment>
                    )}
                  </React.Fragment>
                  <i
                    className="feather-more-vertical"
                    onClick={() => setContextMenuIsOpen(true)}
                  ></i>
                  {ContextMenuIsOpen ? (
                    <React.Fragment>
                      <div
                        className="outline"
                        onClick={() => setContextMenuIsOpen(false)}
                      ></div>
                      <div className="contex-menu">
                        <section
                          className="context-menu-row"
                          onClick={() => toggleRecipientInfo()}
                        >
                          <i className="feather-user"></i>
                          <p>{displayRecipient()}</p>
                        </section>
                        <section
                          className="context-menu-row"
                          onClick={() => toggleJPAInfo()}
                        >
                          <i className="feather-info"></i>
                          <p>{displayJPAinfoText()}</p>
                        </section>
                        <section
                          className="context-menu-row red-row"
                          onClick={() => toggleDeleteConversation()}
                        >
                          <i className="feather-trash-2"></i>
                          <p>Delete conversation</p>
                        </section>
                      </div>
                    </React.Fragment>
                  ) : null}
                  <div className="head-jpa-information">
                    <p>
                      {ChatHeaderInfo.title.length < 35
                        ? ChatHeaderInfo.title
                        : ChatHeaderInfo.title.slice(0, 31) + "..."}
                    </p>
                    <p>
                      <i className="feather-map-pin"></i>
                      {ChatHeaderInfo.workCity.length < 20
                        ? ChatHeaderInfo.workCity
                        : ChatHeaderInfo.workCity.slice(0, 16) + " ..."}
                    </p>
                  </div>
                </section>
              )}
            </React.Fragment>
          ) : null}
          {ChatHeaderInfo === undefined && window.innerWidth > 550 ? (
            <h1 className="select-chat-text">
              {translateText("icp_start_text")}
            </h1>
          ) : null}
          {ChatHeaderInfo === undefined ? null : (
            <section className="messages message-wrapper" id="messages">
              <div
                className="conversation-wrapper"
                id="messages-conversation-wrapper"
              >
                <div className="message-items" id="message-items">
                  {ConversationMessages.map((Item, i) => (
                    <div className="message-row">
                      {Item.senderId === props.UserInfo.id ? (
                        <div className={handleIsMeChatBobbleClassName(i)}>
                          <section className="message-content">
                            {Item.content}
                          </section>
                          <p className="message-info">
                            {displayMessageTime(Item.updatedTime)}
                            <div
                              className={
                                Item.status === "RECEIVED"
                                  ? "message-status blue-checks"
                                  : "message-status silver-checks"
                              }
                            ></div>
                          </p>
                        </div>
                      ) : (
                        <div className={handleChatBobbleClassName(i)}>
                          <section className="message-content">
                            {Item.content}
                          </section>
                          <p className="message-info">
                            {displayMessageTime(Item.updatedTime)}
                          </p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
              {ChatHeaderInfo === undefined ? null : (
                <React.Fragment>
                  <section
                    className="chat-actions"
                    style={
                      ChatHeaderInfo.jpaDeleted ? { pointerEvents: "none" } : {}
                    }
                  >
                    {InputPlaceholderIsShown ? (
                      <p className="message-input-placeholder">
                        {translateText("icp_write_message")} ...
                      </p>
                    ) : null}
                    <div
                      id="message-input-shadow"
                      onChange={() => handleMessageInputSize()}
                    ></div>
                    <textarea
                      className="message-input"
                      disabled={ChatHeaderInfo.jpaDeleted}
                      id="message-input"
                      onChange={(e) => handleMessageInput(e)}
                      onKeyDown={(e) => handleKeyPress(e)}
                      onClick={() =>
                        setTimeout(() => {
                          scrollConversation();
                        }, 500)
                      }
                    />
                    <button
                      className="send"
                      onClick={() => togglesendMessage()}
                    >
                      <i className="feather-send"></i>
                    </button>
                  </section>
                </React.Fragment>
              )}
            </section>
          )}
        </div>
      </main>
    </div>
  );
};

export default Communication;
